import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_8'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
